import { Box, Stack, Text } from 'braid-design-system';

import * as styles from './index.css';

export const ErrorSectionLayout = ({
  children,
  heading,
  image,
}: {
  children: React.ReactNode;
  heading: string;
  image: React.ReactNode;
}) => (
  <Box width="full" height="full" className={styles.fullPageBody}>
    <Box
      background="surface"
      width="full"
      height="full"
      paddingTop={['large', 'xxlarge', 'xxlarge']}
      display="flex"
      justifyContent="center"
    >
      <Box paddingX="large" maxWidth="xsmall">
        <Stack space="large" align="center">
          <Box marginBottom="xsmall">{image}</Box>
          <Text>
            <Box className={styles.heading} component="span">
              {heading}
            </Box>
          </Text>
          <Box>{children}</Box>
        </Stack>
      </Box>
    </Box>
  </Box>
);
